<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div>
    <!-- <SmoothHeight> -->
    <v-data-table
      :hover="labelStore.loadingState !== 'loading'"
      :loading="labelStore.loadingState === 'loading'"
      item-value="raw"
      :headers="[
        {
          title: i18n.global.t('app.printLabels.info.preview'),
          key: 'preview',
          sortable: false,
          width: 0,
        },
        {
          title: i18n.global.t('app.printLabels.info.label'),
          key: 'label',
          sortRaw(a, b) {
            return a.label.title > b.label.title ? 1 : -1;
          },
        },
        {
          title: i18n.global.t('app.printLabels.info.size'),
          key: 'dimensions',
          align: 'end',
          sortRaw(a, b) {
            const filteredA = String(a.dimensions)
              .replace(/\D+/g, ' ')
              .trim()
              .split(' ')
              .map((e) => parseInt(e));
            let resultA = 1;
            for (const iterator of filteredA) {
              resultA *= iterator;
            }
            const filteredB = String(b.dimensions)
              .replace(/\D+/g, ' ')
              .trim()
              .split(' ')
              .map((e) => parseInt(e));
            let resultB = 1;
            for (const iterator of filteredB) {
              resultB *= iterator;
            }

            return resultA > resultB ? 1 : -1;
          },
        },
        {
          title: i18n.global.t('app.printLabels.info.print'),
          key: 'download',
          sortable: false,
          width: 0,
        },
      ]"
      :items="
        labelStore.labels.map((e) => ({
          label: {
            title: e.Layout,
            subtitle: e.MaterialDescription,
          },
          preview: e,
          download: e,
          dimensions: e.LayoutSize,
        }))
      "
    >
      <template v-slot:item.label="{ value }: { value: { title: string, subtitle: string } }">
        <v-list-item
          class="px-0 min-w-64"
          :title="value.title"
          :subtitle="value.subtitle || i18n.global.t('global.noDescription')"
        ></v-list-item>
      </template>
      <template v-slot:item.preview="{ value }">
        <PreviewButton v-if="value.Released" :label="value"></PreviewButton>
      </template>
      <template v-slot:item.dimensions="{ value }">
        <v-list-item
          class="px-0 min-w-24"
          :subtitle="getDinFormatFromSize(value) ? `DIN ${getDinFormatFromSize(value)} (${value} mm)` : `${value} mm`"
        >
        </v-list-item>
      </template>
      <template v-slot:item.download="{ value }">
        <DownloadArea :label="value"></DownloadArea>
      </template>

      <template v-slot:loading>
        <div v-for="index in 3" :key="index">
          <div class="flex justify-between flex-row">
            <div class="flex">
              <v-skeleton-loader type="avatar"></v-skeleton-loader>
              <v-skeleton-loader class="min-w-64" type="list-item-two-line"></v-skeleton-loader>
            </div>
            <v-skeleton-loader class="min-w-36" type="text@1"></v-skeleton-loader>
          </div>
          <v-skeleton-loader class="min-w-36" type="divider"></v-skeleton-loader>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script setup lang="ts">
// helpers
import { i18n } from "@/locales/index";
import { getDinFormatFromSize } from "@/helpers/textFormat";
// instances
import { useLabelStore, useMaterialStore } from "@/store";
// components
import PreviewButton from "./PreviewButton.vue";
import DownloadArea from "./DownloadArea.vue";
import { watch } from "vue";

// get instances
const labelStore = useLabelStore();
const materialStore = useMaterialStore();

labelStore.loadingState = "loading";

materialStore.onAbort.addListener("abort", () => {
  labelStore.abortGetLabels();
});

// get labels
watch(
  () => materialStore.loadingState,
  (state) => {
    if (state === "loading") {
      labelStore.loadingState = "loading";
      return;
    }
    if (state === "failed") {
      labelStore.loadingState = "failed";
      labelStore.labels = [];
      return;
    }
    if (state !== "success") return;

    labelStore.getLabels();
  }
);
</script>
